import React from "react";
import { Col } from "react-bootstrap";
import gutter from "src/functions/gutter";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";

function PricesIntroEn() {
  return (
    <>
      <Col xs={{ span: 12, order: 1 }} sm={6} lg={{ span: 4, order: 1 }}>
        <Heading type={`h2`} variant={`primary`} title={`Prodej po kusech`} />
        <Paragraph size={`md`} width={`semibold`}>
          Plaťte pouze za to, co skutečně používáte
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Chcete si koupit prémiový obsah, vyzkoušet naši platformu nebo cvičíte
          jen občas? Vyberte si kurz nebo lekci, která vám vyhovuje a plaťte
          pouze za to, co si odcvičíte. Ceny obsahu si určují lektoři sami.
        </Paragraph>
        <br />
      </Col>
      <Col xs={{ span: 12, order: 3 }} sm={6} lg={{ span: 4, order: 2 }}>
        <Heading type={`h2`} variant={`primary`} title={`Obsah zdarma`} />
        <Paragraph size={`md`} width={`semibold`}>
          Vyzkoušejte ukázkové lekce zdarma!
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Chcete si vyzkoušet, jestli vám přístup vybrané lektorky nebo lektora
          sedí, než si koupíte nabízený kurz nebo lekci? Zobrazete si lektorský
          profil a najděte ukázkové lekce zdarma. Jsou označené značkou Ukázka.
          Díky tomu budete mít jistotu, že jste zvolili správně.
        </Paragraph>
        <br />
      </Col>
      <Col xs={{ span: 12, order: 5 }} sm={6} lg={{ span: 4, order: 3 }}>
        <Heading type={`h2`} variant={`primary`} title={`Předplatné`} />
        <Paragraph size={`md`} width={`semibold`}>
          Vyhovuje vám více měsíční předplatné?
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Pro ty z vás, kteří mají rádi neomezený přístup k obsahu, máme dobrou
          zprávu. V blízké budoucnosti spustíme předplatné. To vám umožní
          objevovat kurzy a lekce různých lektorů bez omezení.
        </Paragraph>
        <br />
      </Col>
    </>
  );
}

export default PricesIntroEn;
